import { render, staticRenderFns } from "./DashboardFilter.vue?vue&type=template&id=55a37b1b&scoped=true&"
import script from "./DashboardFilter.vue?vue&type=script&lang=js&"
export * from "./DashboardFilter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFilter.vue?vue&type=style&index=0&id=55a37b1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a37b1b",
  null
  
)

export default component.exports